export const SESSION_DETAIL_START_LOADING = "session_detail/initiate_loading";
export const SESSION_DETAIL_FAILED_LOADING = "session_detail/failed_loading";
export const SESSION_DETAIL_SUCCESSFUL_LOADING = "session_detail/successful_loading";
export const SESSION_DETAIL_VALUE = "session_detail/value";
export const SESSION_DETAIL_RESET = "session_detail/reset";
